import axios from "axios";
// import Vue from "vue";

// export const API_URL = "http://yccx-api.tra.ycdrlx.com";
axios.defaults.withCredentials = true;
// 创建一个axios实例
const api = axios.create({
  //请求超时配置
  timeout: 60 * 1000,
  withCredentials: true,
  // baseURL: "/api",
  // baseURL: API_URL,
  // baseURL: "http://220513.test"
});
//添加请求拦截器
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    console.log(err);
  }
);
//添加响应拦截器
api.interceptors.response.use(
  (response) => {
    let res = {};
    res.status = response.status;
    res.data = response.data;
    return res;
  },
  () => {}
);

export default api;
